// #region imports

// --- HS Code
import { CommandOfT } from "../shared/command";
import { GroupModel } from "./group-model";
import { RespondentModel } from "./respondent-model";
import { RespondentStatuses } from "./respondent-statuses";

// #endregion


export class AddRespondentCommand implements CommandOfT<GroupModel[]>
{
  private _isExecuted: boolean;

  private readonly _newRespondent: RespondentModel;
  private readonly _groups: GroupModel[];

  private _placeHolderRespondent: RespondentModel | undefined;

  get groups(): GroupModel[] {
    if (!this._isExecuted) throw new Error('The command has not yet been executed. No changes have been affected!');
    return this._groups;
  }

  constructor(respondent: RespondentModel, groups: GroupModel[]) {
    this._isExecuted = false;
    this._newRespondent = respondent;
    this._groups = groups;
  }

  execute(): GroupModel[] {
    this._newRespondent.percentageComplete = 0;
    this._newRespondent.status = RespondentStatuses.notStarted;

    if (this._isExecuted) return this._groups;

    const destinationGroup = this._groups.find(g => g.id.toLowerCase() === this._newRespondent.groupId.toLowerCase());
    if (!destinationGroup) return this._groups;

    const destinationIndex = destinationGroup.respondents.findIndex(r => r.groupIndex === this._newRespondent.groupIndex);
    if (destinationIndex < 0) return this._groups;

    this._isExecuted = true;
    this._placeHolderRespondent = destinationGroup.respondents.splice(destinationIndex, 1, this._newRespondent).at(0);

    return this._groups;
  }

  undo(): GroupModel[] {
    if (!this._isExecuted) return this._groups;

    const destinationGroup = this._groups.find(g => g.id.toLowerCase() === this._newRespondent.groupId.toLowerCase());
    if (!destinationGroup) return this._groups;

    const destinationIndex = destinationGroup.respondents.findIndex(r => r.groupIndex === this._newRespondent.groupIndex);
    if (destinationIndex < 0) return this._groups;

    if (!this._placeHolderRespondent) return this._groups;

    this._placeHolderRespondent = destinationGroup.respondents.splice(destinationIndex, 1, this._placeHolderRespondent).at(0);

    return this._groups;
  }
}
